<template>
  <div
    class="tollbar-con"
    :class="{
      news: theme == '0',
      sanction: theme == '1',
      gray: isFilterDis,
      product: type == '3',
    }"
  >
    <div class="tollbar-con-filter">
      <el-button
        round
        class="tollbar-con-filter-btn"
        :disabled="isFilterDis"
        @click="onSwitchSearch"
        ><i class="iconfont icon-xingzhuangjiehe"></i>{{ $t("Toolbar.Filter") }}</el-button
      >
    </div>
    <div class="tollbar-con-list">
      <div
        class="tollbar-con-list-item"
        :class="{
          dis: item.disabled,
          active: activeName == item.name,
        }"
        v-for="(item, index) in list"
        :key="index"
        @click.stop="onTollbar($event, item)"
      >
        <!-- 排序下拉 -->
        <el-dropdown
          trigger="click"
          placement="bottom"
          v-if="item.name == 'Sort by'"
        >
          <div class="el-dropdown-link">
            <i
              class="iconfont tollbar-con-list-item-icon"
              :class="item.icon"
              id="target"
            ></i>
            <div class="tollbar-con-list-item-name" id="target">
              {{ item.name }}
            </div>
            <i
              class="iconfont icon-jiantouxia icon-select"
              v-show="item.select"
              id="target"
            ></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-cascader-panel
              ref="cascader"
              v-model="sortSelectList"
              :options="sortList"
              @change="onChangeSelect"
              :props="{ multiple: false }"
              class="new-search-select"
            ></el-cascader-panel>
            <!-- <el-dropdown-item
              v-for="(list, index) in moreTool"
              :key="index"
              :disabled="list.disabled"
              class="tollbar-con-more-list-item-name"
            >
              <i class="iconfont" :class="list.icon"></i>
              {{ list.name }}</el-dropdown-item
            >-->
          </el-dropdown-menu>
        </el-dropdown>
        <template v-else>
          <i
            class="iconfont tollbar-con-list-item-icon"
            :class="item.icon"
            id="target"
          ></i>
          <div class="tollbar-con-list-item-name" id="target">
            {{ item.name }}
          </div>
          <i
            class="iconfont icon-jiantouxia icon-select"
            v-show="item.select"
            id="target"
          ></i>
        </template>
      </div>
      <!--更多下拉 -->
      <el-dropdown trigger="click" v-if="moreTool != false">
        <div class="el-dropdown-link">
          <i class="iconfont icon-gengduo2" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(list, index) in moreTool"
            :key="index"
            :disabled="list.disabled"
            class="tollbar-con-more-list-item-name"
          >
            <i class="iconfont" :class="list.icon"></i>
            {{ list.name }}</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <!-- 导出弹窗 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title"
      :visible.sync="fieldVisible"
      class="new-dialog dialog-800"
      :class="{ 'export-dialog': modalLevel == 2 }"
      @close="onCancelField"
    >
      <div class="new-dialog-body" :class="{ 'flex-box': modalLevel == 1 }">
        <!-- 第一步 -->
        <template v-if="modalLevel == 1">
          <div class="new-dialog-body-select">
            <el-checkbox
              :indeterminate="isIndeterminate"
              v-model="checkAll"
              @change="onChangeAllCondition"
              class="new-check-all"
            >
              All
            </el-checkbox>
            <el-checkbox-group
              v-model="checkedCondition"
              @change="onChangeCondition"
              class="new-check-list"
            >
              <el-checkbox
                v-for="(item, index) in conditionsList"
                :key="index"
                :label="item"
              >
                {{ item }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
          <div class="new-dialog-body-list">
            <div class="new-dialog-body-list-title">
              Selected Columns ({{ checkedCondition.length }})
            </div>
            <div class="new-dialog-body-list-con">
              <div
                v-for="(item, index) in checkedCondition"
                :key="index"
                class="new-dialog-body-list-con-item"
              >
                <div class="new-delete-title">{{ item }}</div>
                <div class="new-delete-icon" @click="onDeleteCondition(item)">
                  <i class="iconfont icon-cuowu"></i>
                </div>
              </div>
            </div>
          </div>
        </template>
        <!-- 第二步 -->
        <template v-else>
          <div class="export-dialog-title">
            How many results would you like to export form this search? You may
            also fefine your search by including additional filter(s).
          </div>
          <div class="export-dialog-con">
            <div class="export-dialog-con-label">File name:</div>
            <el-input
              class="export-dialog-con-input"
              v-model="exportName"
              maxlength="20"
              placeholder="Please enter the file name"
            ></el-input>
          </div>
        </template>
      </div>
      <div slot="footer" class="right new-dialog-footer">
        <template v-if="modalLevel == 1">
          <div class="new-dialog-footer-link" @click="onResetCondition">
            Reset Default View
          </div>
          <el-button
            class="new-dialog-footer-btn"
            :disabled="checkedCondition.length === 0"
            @click.stop="onNext"
          >
            Apply Changes
          </el-button>
        </template>
        <template v-else>
          <el-button class="cancel new-dialog-footer-btn" @click="onCancel">
            Cancel
          </el-button>
          <el-button class="new-dialog-footer-btn" @click.stop="onBack">
            Back
          </el-button>
          <el-button
            class="new-dialog-footer-btn"
            @click="onExport"
            :disabled="!exportName"
          >
            Export
          </el-button>
        </template>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "Tollbar",
  props: {
    isShowSearch: {
      type: Boolean,
      default: false,
    },
    isShowSelect: {
      type: Boolean,
      default: false,
    },
    isFilterDis: {
      type: Boolean,
      default: false,
    },
    isShowExport: {
      type: Boolean,
      default: true, //导出是否展示弹窗 默认展示
    },
    type: {
      type: String,
      default: "", // 0 新闻 1 制裁-公司 2 制裁-人 3 制裁-产品
    },
    theme: {
      type: String,
      default: "",
    },
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },
    moreTool: {
      type: Array,
      default: () => {
        return [];
      },
    },
    selectList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    sortList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    conditionsList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  watch: {
    selectList: {
      handler(newVal) {
        this.selectList = newVal;
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    _isShowSearch: {
      get() {
        return this.isShowSearch;
      },
      set(val) {
        this.$emit("update:isShowSearch", val);
      },
    },
    _isShowSelect: {
      get() {
        return this.isShowSelect;
      },
      set(val) {
        this.$emit("update:isShowSelect", val);
      },
    },
  },
  data() {
    return {
      activeName: "",
      sortSelectList: [""],
      fieldVisible: false,
      exportVisible: false,
      exportName: "",
      isIndeterminate: false,
      checkAll: false,
      checkedCondition: [],
      checkedConditionCopy: [],
      listLength: 300,
      title: "Export Fields",
      modalLevel: 1,
    };
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    onClearSearch() {
      this.$emit("onClearSearch");
    },
    onChangeAllCondition(val) {
      this.checkedCondition = val ? this.conditionsList : [];
      this.isIndeterminate = false;
    },
    onChangeCondition(val) {
      this.checkedCondition = val;
      let checkedCount = val.length;
      this.checkAll = checkedCount === this.conditionsList.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.conditionsList.length;
    },
    onDeleteCondition(val) {
      this.checkedCondition = this.checkedCondition.filter(
        (item) => item !== val,
      );
      let checkedCount = this.checkedCondition.length;
      this.checkAll = checkedCount === this.conditionsList.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.conditionsList.length;
    },
    onResetCondition() {
      this.checkedCondition = [];
      this.isIndeterminate = false;
      this.checkAll = false;
    },
    onRestExport() {
      this.activeName = "";
      this.exportName = "";
      this.checkedCondition = [];
      this.isIndeterminate = false;
      this.checkAll = false;
    },
    // 下一步
    onNext() {
      this.modalLevel = 2;
      this.title = `Export (${this.listLength} results)`;
      this.checkedConditionCopy = this.checkedCondition;
    },
    //关闭导出弹窗
    onCancelField() {
      this.modalLevel = 1;
      this.fieldVisible = false;
      this.onRestExport();
    },
    // 取消
    onCancel() {
      this.modalLevel = 1;
      this.fieldVisible = false;
      this.onRestExport();
    },
    // 返回上一步
    onBack() {
      this.modalLevel = 1;
      this.exportName = "";
      this.checkedCondition = this.checkedConditionCopy;
      let checkedCount = this.checkedCondition.length;
      this.checkAll = checkedCount === this.conditionsList.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.conditionsList.length;
    },
    // 导出
    onExport() {
      // this.exportVisible = true;
    },
    onSwitchSearch() {
      this._isShowSearch = !this._isShowSearch;
    },
    onSwitchSelect() {
      this._isShowSelect = !this._isShowSelect;
    },
    onTollbar(e, item) {
      if (!item.disabled) {
        if (item.name !== "Sort by") {
          if (this.activeName == item.name) {
            this.activeName = "";
          } else {
            this.activeName = item.name;
          }
        } else {
          if (e.target.id) {
            if (this.activeName == item.name) {
              this.activeName = "";
            } else {
              this.activeName = item.name;
            }
          }
        }
        this.$emit("menuClick", item, this.activeName);
        if (item.name === "Select") {
          this.onSwitchSelect();
        } else if (item.name === "Export") {
          if (this.isShowExport) {
            this.fieldVisible = true;
          } else {
            this.$emit("onExport");
          }
        }
      }
    },
    onChangeSelect(e) {
      this.sortSelectList = e;
      this.$emit("onChangeSort", e);
      if (Array.isArray(e)) {
        if (e.length === 0) {
          this.$refs.cascader.$refs.panel.checkedValue = []; // 清空选中值
          this.$refs.cascader.$refs.panel.clearCheckedNodes(); // 清空级联选择器选中状态
          this.$refs.cascader.$refs.panel.activePath = []; // 清除高亮
          this.$refs.cascader.$refs.panel.syncActivePath(); // 初始化（只展示一级节点）
        } else {
          this.activeName = "";
        }
      }
    },
  },
};
</script>
<style scoped>
.new-layout-con .tollbar-con {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 56px;
  padding-left: 30px;
  padding-right: 40px;
  background: #ffffff;
  box-shadow: 0px 2px 4px 0px rgba(121, 109, 144, 0.3);
}
.news-theme .new-layout-con .tollbar-con {
  box-shadow: 0px 2px 4px 0px #22af5c;
}
.sanction-theme .new-layout-con .tollbar-con {
  box-shadow: 0px 2px 4px 0px rgba(160, 63, 40, 0.3);
  position: relative;
  z-index: 998;
}
.new-layout-con .tollbar-con-filter {
  display: flex;
  align-items: center;
  height: 34px;
}
.new-layout-con .tollbar-con-filter-icon {
  width: 20px;
  height: 15px;
  margin-right: 20px;
  cursor: pointer;
}
.new-layout-con .tollbar-con-filter-btn {
  width: 120px;
  height: 36px;
  padding: 0;
  border-radius: 20px;
}
.news-theme .new-layout-con .tollbar-con-filter-btn {
  background: #3ebb72;
}
.sanction-theme .new-layout-con .tollbar-con-filter-btn {
  background: #f9722c;
}
.new-layout-con .tollbar-con-filter-btn.is-disabled {
  background: #eeeeee !important;
}
.new-layout-con .tollbar-con-filter-btn >>> span {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #ffffff;
}
.new-layout-con .tollbar-con-filter-btn >>> i {
  margin-right: 6px;
  font-size: 12px;
}
.new-layout-con .tollbar-con-filter-btn.is-disabled >>> span {
  color: #999999;
}

.new-layout-con .tollbar-con-filter-con {
  display: flex;
  cursor: pointer;
}
.new-layout-con .tollbar-con-filter-con-left {
  display: flex;
  align-items: center;
  height: 34px;
  margin-right: 1px;
  padding-left: 14px;
  padding-right: 8px;
  border-radius: 4px 0px 0px 4px;
}
.new-layout-con .news .tollbar-con-filter-con-left {
  background: #3ebb72;
}
.new-layout-con .sanction .tollbar-con-filter-con-left {
  background: #f9722c;
}
.new-layout-con .gray .tollbar-con-filter-con-left {
  background: #eeeeee;
}
.new-layout-con .tollbar-con-filter-con-left > i {
  margin-right: 6px;
  font-size: 16px;
  color: #ffffff;
}
.new-layout-con .gray .tollbar-con-filter-con-left > i {
  color: #999999;
}
.new-layout-con .tollbar-con-filter-con-left-txt {
  width: 46px;
  font-size: 16px;
  color: #ffffff;
}
.new-layout-con .gray .tollbar-con-filter-con-left-txt {
  color: #999999;
}
.new-layout-con .tollbar-con-filter-con-right {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 28px;
  height: 34px;
  border-radius: 0 4px 4px 0px;
}
.new-layout-con .news .tollbar-con-filter-con-right {
  background: #3ebb72;
}
.new-layout-con .sanction .tollbar-con-filter-con-right {
  background: #f9722c;
}
.new-layout-con .gray .tollbar-con-filter-con-right {
  background: #eeeeee;
  cursor: not-allowed;
}
.new-layout-con .tollbar-con-filter-con-right > i {
  font-size: 14px;
  color: #ffffff;
}
.new-layout-con .gray .tollbar-con-filter-con-right > i {
  color: #999999;
}
.new-layout-con .tollbar-con-list {
  display: flex;
  height: 26px;
  line-height: 26px;
}
.new-layout-con .tollbar-con-list-item {
  display: flex;
  align-items: center;
  margin-right: 30px;
  cursor: pointer;
}
.new-layout-con .tollbar-con-list-item:last-child {
  margin-right: 0;
}
.new-layout-con .dis.tollbar-con-list-item {
  cursor: not-allowed;
}
.new-layout-con .tollbar-con-list-item-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 18px;
  height: 18px;
  margin-right: 5px;
  font-size: 16px;
  color: #1a2332;
}
.new-layout-con .dis.tollbar-con-list-item i {
  color: #999999;
}
.new-layout-con .news .tollbar-con-list-item:hover i,
.new-layout-con .news .active.tollbar-con-list-item i {
  color: #3ebb72;
}
.new-layout-con .sanction .tollbar-con-list-item:hover i,
.new-layout-con .sanction .active.tollbar-con-list-item i {
  color: #f9722c;
}
.new-layout-con .dis.tollbar-con-list-item:hover i {
  color: #999999;
}
.new-layout-con .tollbar-con-list-item-icon.icon-daochu04 {
  font-size: 17px;
}
.new-layout-con .tollbar-con-list-item-icon.icon-xuanze,
.new-layout-con .tollbar-con-list-item-icon.icon-filter,
.new-layout-con .tollbar-con-list-item-icon.icon-baocun {
  font-size: 18px;
}
.new-layout-con .tollbar-con-list-item-icon.icon-xiazai {
  font-size: 19px;
}
.new-layout-con .tollbar-con-list-item-icon.icon-shoucang1,
.new-layout-con .tollbar-con-list-item-icon.icon-judan,
.new-layout-con .tollbar-con-list-item-icon.icon-gudong {
  font-size: 20px;
}
.new-layout-con .tollbar-con-list-item-icon.icon-bianji1 {
  font-size: 24px;
}
.new-layout-con .icon-select {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 10px;
  height: 6px;
  margin-left: 6px;
  margin-top: 4px;
  margin-right: 0 !important;
  font-size: 14px !important;
}
.new-layout-con .tollbar-con-list-item-name {
  font-size: 16px;
  color: #1a2332;
}
.html-new-page .tollbar-con-more-list-item-name {
  font-size: 16px;
  color: #1a2332;
}
.html-new-page .tollbar-con-more-list-item-name.is-disabled {
  color: #999999;
}
.new-layout-con .dis .tollbar-con-list-item-name {
  color: #999999;
}
.new-layout-con .news .tollbar-con-list-item:hover div,
.new-layout-con .news .active.tollbar-con-list-item div {
  color: #3ebb72;
}
.new-layout-con .sanction .tollbar-con-list-item:hover div,
.new-layout-con .sanction .active.tollbar-con-list-item div {
  color: #f9722c;
}
.new-layout-con .dis.tollbar-con-list-item:hover div {
  color: #999999;
}
.filter-popper-con {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  cursor: pointer;
}
.filter-popper-con > i {
  margin-right: 6px;
  font-size: 17px;
  color: #ff6a6a;
}
.filter-popper-con-txt {
  font-size: 16px;
  color: #1a2332;
}
.sort-con {
  position: fixed;
  top: 133px;
  left: 742px;
  pointer-events: none;
  z-index: 999;
}
.sort-show-popper {
  pointer-events: all;
}
.sort-con >>> .el-cascader-menu {
  width: 200px;
  min-width: 200px;
  z-index: 8;
}
.product .sort-con >>> .el-cascader-menu:nth-child(2) {
  width: 300px;
}
.sort-con >>> .el-cascader-node {
  padding-right: 38px !important;
}
.sort-con >>> .el-icon-arrow-right {
  right: 14px;
}
.export-dialog-title {
  line-height: 30px;
  margin-bottom: 30px;
  font-size: 20px;
  color: #1a2332;
  word-break: break-word;
}
.export-dialog-con {
  display: flex;
  align-items: center;
  height: 56px;
}
.export-dialog-con-label {
  width: 104px;
  font-size: 20px;
  color: #1a2332;
}
.export-dialog-con-input {
  width: calc(100% - 104px);
}
.export-dialog-con-input >>> .el-input__inner::placeholder {
  color: #999999;
}
.export-dialog-con-input >>> .el-input__inner {
  height: 56px;
  padding: 0 14px;
  font-size: 20px;
  color: #1a2332;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #cccccc;
}
.export-dialog >>> .el-dialog__footer {
  padding: 30px 30px 40px 30px;
}
.el-dropdown-link {
  cursor: pointer;
  display: flex;
  align-items: center;
}
@media (max-width: 1920px) {
  .new-layout-con .tollbar-con {
    height: 40px;
    padding-left: 20px;
    padding-right: 26px;
    box-shadow: 0px 1px 2px 0px rgba(121, 109, 144, 0.3);
  }
  .new-layout-con .tollbar-con-filter {
    height: 24px;
  }
  .new-layout-con .tollbar-con-filter-icon {
    width: 14px;
    height: 10px;
    margin-right: 14px;
  }
  .new-layout-con .tollbar-con-filter-btn {
    width: 80px;
    height: 24px;
    border-radius: 14px;
  }
  .new-layout-con .tollbar-con-filter-btn >>> span {
    font-size: 12px;
  }
  .new-layout-con .tollbar-con-filter-btn >>> i {
    margin-right: 4px;
    font-size: 12px;
    transform: scale(0.8);
  }
  .new-layout-con .tollbar-con-filter-con-left {
    height: 24px;
    padding-left: 10px;
    padding-right: 5px;
    border-radius: 3px 0px 0px 3px;
  }
  .new-layout-con .tollbar-con-filter-con-left > i {
    margin-right: 4px;
    font-size: 12px;
  }
  .new-layout-con .tollbar-con-filter-con-left-txt {
    width: 38px;
    font-size: 12px;
  }
  .new-layout-con .tollbar-con-filter-con-right {
    width: 20px;
    height: 24px;
    border-radius: 0 3px 3px 0px;
  }
  .new-layout-con .tollbar-con-filter-con-right > i {
    font-size: 10px;
  }
  .new-layout-con .tollbar-con-list {
    height: 18px;
    line-height: 18px;
  }
  .new-layout-con .tollbar-con-list-item {
    margin-right: 20px;
  }
  .new-layout-con .tollbar-con-list-item-icon {
    width: 14px;
    height: 14px;
    margin-right: 3px;
    font-size: 12px;
  }
  .new-layout-con .tollbar-con-list-item-icon.icon-daochu04 {
    font-size: 13px;
  }
  .new-layout-con .tollbar-con-list-item-icon.icon-xuanze,
  .new-layout-con .tollbar-con-list-item-icon.icon-filter,
  .new-layout-con .tollbar-con-list-item-icon.icon-baocun {
    font-size: 14px;
  }
  .new-layout-con .tollbar-con-list-item-icon.icon-xiazai {
    font-size: 15px;
  }
  .new-layout-con .tollbar-con-list-item-icon.icon-shoucang1,
  .new-layout-con .tollbar-con-list-item-icon.icon-judan,
  .new-layout-con .tollbar-con-list-item-icon.icon-gudong {
    font-size: 16px;
  }
  .new-layout-con .tollbar-con-list-item-icon.icon-bianji1 {
    font-size: 20px;
  }
  .new-layout-con .icon-select {
    width: 8px;
    height: 4px;
    margin-left: 4px;
    font-size: 10px !important;
  }
  .new-layout-con .tollbar-con-list-item-name {
    font-size: 14px;
  }
  .html-new-page .tollbar-con-more-list-item-name {
    font-size: 14px;
  }
  .filter-popper-con {
    height: 33px;
  }
  .filter-popper-con > i {
    margin-right: 4px;
    font-size: 14px;
  }
  .filter-popper-con-txt {
    font-size: 12px;
  }
  .sort-con {
    top: 90px;
    left: 420px;
  }
  .sort-con >>> .el-cascader-menu {
    width: 150px;
    min-width: 150px;
  }
  .product .sort-con >>> .el-cascader-menu:nth-child(2) {
    width: 200px;
  }
  .sort-con >>> .el-cascader-node {
    padding-right: 26px !important;
  }
  .sort-con >>> .el-icon-arrow-right {
    right: 10px;
  }
  .export-dialog-title {
    line-height: 20px;
    margin-bottom: 20px;
    font-size: 16px;
  }
  .export-dialog-con {
    height: 40px;
  }
  .export-dialog-con-label {
    width: 80px;
    font-size: 16px;
  }
  .export-dialog-con-input {
    width: calc(100% - 80px);
  }
  .export-dialog-con-input >>> .el-input__inner {
    height: 40px;
    padding: 0 10px;
    font-size: 16px;
    border-radius: 5px;
  }
  .export-dialog >>> .el-dialog__footer {
    padding: 20px 20px 26px 20px;
  }
}
@media (max-width: 1439px) {
  .new-layout-con .tollbar-con {
    padding-left: 14px;
    padding-right: 20px;
  }
  .new-layout-con .tollbar-con-list-item {
    margin-right: 12px;
  }
  .new-layout-con .tollbar-con-list-item-name {
    font-size: 12px;
  }
  .html-new-page .tollbar-con-more-list-item-name {
    font-size: 12px;
  }
}
</style>
